import MuiButton from "@mui/material/Button";
import MuiDrawer from "@mui/material/Drawer";
import MuiListItemButton from "@mui/material/ListItemButton";
/* eslint-disable quote-props */
import { styled } from "@mui/material";

export const Box = styled("div")(() => ({
  zIndex: "1000",
  width: "100%",
  position: "fixed",
  top: 0,
  left: 0,
  "> header": {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "spaceBetween",
    backgroundColor: "#FFFFFF",
    boxShadow: "none",
    borderBottom: "1px solid #E8DFD7",
    padding: "16px 16px 16px 24px",
    top: "55px",
  },
}));

export const Logo = styled("div")(() => ({
  flex: "2",
  "img": {
    width: "119px",
  },
}));

export const Drawer = styled(MuiDrawer)(() => ({
  "flexShrink": 0,
  "& .MuiDrawer-paper": {
    width: 280,
    overflow: "hidden",
    boxShadow: "none",
    "ul": {
      padding: "1rem 0",
    },
    ".active": {
      position: "relative",
    },
  },
  ".hospital": {
    position: "relative",
    padding: "24px 24px 16px",
  },
}));

export const Button = styled(MuiButton)(() => ({
  margin: "1rem 0",
  "width": "100%",
  "a": {
    margin: "0 10px",
  },
}));

export const ListItemButton = styled(MuiListItemButton)(() => ({
  display: "flex",
  alignItems: "center",
  "span": {
    fontFamily: "atlas-grotesk-regular",
    fontSize: "13px",
  },
}));


